import React, { useState, useEffect } from 'react';
import Icon from '../../component/Icon';
import Inputbox from '../../component/Inputbox';
import { useSelector, useDispatch } from 'react-redux';
import { Formik } from 'formik';
import PasswordUpdate from '../../component/PasswordUpdate';
import * as actionCreators from '../../store/actionCreators/index';
import { useNavigate } from 'react-router-dom';
import * as Action from '../../store/actions/index';
const person =
  'https://thumbs.dreamstime.com/b/happy-person-portrait-smiling-woman-tanned-skin-curly-hair-happy-person-portrait-smiling-young-friendly-woman-197501184.jpg';
function UserSetting() {
  const navigate = useNavigate();
  const state = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  console.log(state);
  return (
    <div>
      <h2 className='text-3xl mb-4 text-greySecondary text-center font-[500] capitalize'>
        Welcome {state.user.firstname + ' ' + state.user.lastname}
      </h2>
      <div className='flex justify-center item-center '>
        {/* MAIN CONTAINER */}
        <div className='p-4 bg-white shadow-xl rounded-lg'>
          <div className='flex items-center gap-4'>
            <Icon name='edit' className='w-5 h-5' />
            <h2>Edit Profile</h2>
          </div>
          <div className='p-4 mb-4'>
            <h1 className='font-[500] text-lg'>Personal Information</h1>
            <p className='text-sm text-greySecondary'>
              Update your account’s profile and email address
            </p>
          </div>

          {/* CONTAINER */}
          <Formik
            initialValues={{
              firstname: `${state.user.firstname}`,
              lastname: `${state.user.lastname}`,
              phone: `${state.user.phone}`,
              email: `${state.user.email}`,
            }}
            onSubmit={(values) => {
              dispatch(
                actionCreators.editUser(
                  state.user.id,
                  values,
                  setLoading,
                  state.token
                )
              );

              console.log(values);
            }}
          >
            {(props) => (
              <div className='flex mb-12 gap-16'>
                <div>
                  <img
                    src={person}
                    alt='profile'
                    className='block object-contain h-[12rem] rounded-xl'
                  />
                </div>
                <div>
                  <form onSubmit={props.handleSubmit}>
                    <div className='flex gap-2 mb-2 items-center justify-between'>
                      <Inputbox
                        onChange={props.handleChange}
                        type='text'
                        name='firstname'
                        value={props.values.firstname}
                        placeholder='John'
                        title='Firstname'
                      />
                      <Inputbox
                        onChange={props.handleChange}
                        value={props.values.lastname}
                        type='text'
                        name='lastname'
                        placeholder='Doe'
                        title='Lastname'
                      />
                    </div>
                    <div className='flex gap-2 mb-2 items-center justify-between'>
                      <Inputbox
                        onChange={props.handleChange}
                        value={props.values.email}
                        type='email'
                        name='email'
                        placeholder='john@gmail.com'
                        title='Email'
                      />
                      <Inputbox
                        onChange={props.handleChange}
                        value={props.values.phone}
                        type='number'
                        name='phone'
                        placeholder='9854784512'
                        title='Phone number'
                      />
                    </div>
                    <button
                      type='submit'
                      className='bg-darkPrimary ml-auto block w-[5rem] p-2 rounded-lg text-white font-[500] text-base'
                    >
                      Save
                    </button>
                  </form>
                </div>
              </div>
            )}
          </Formik>
          {/* UPDATE PASSWORD */}
          <PasswordUpdate />

          {/* DONE AND CANCEL BUTTONS */}
          <div className='flex gap-2 text-white font-[600] justify-end mt-16 text-base'>
            <button
              onClick={() => {
                dispatch({
                  type: Action.CREATE_ERROR,
                  payload: {
                    msg: 'Update Done',
                    type: 'success',
                  },
                });
                navigate('/');
              }}
              className='bg-orange-400 p-2 w-[6rem] rounded-lg'
            >
              Done
            </button>
            <button className='bg-red-600 p-2 w-[6rem] rounded-lg'>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserSetting;
